import React, { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";

import { fetchNewDevices } from "../../../store/devices/devices.actions";
import { DevicesSets, TABS } from "../../../helpers/devices.helpers";
import { DiscoveredDevicesTable } from "./discoveredDevicesTable";
import { InfectedDevicesTable } from "./infectedDevicesTable";
import { BlockedDevicesTable } from "./blockedDevicesTable";
import { RoamingDevicesTable } from "./roamingDeviceTable";
import { useMount } from "@sportal/cdk/hooks";
import { createDeviceTab } from "../../../components/tabList";
import { isSPSONAvailable } from "../../../store/account";
import { TabsContext } from "./shared/components";
import { fetchLines } from "../../../store/devices/lines";
import { fetchInfected } from "../../../store/devices/infectedDevices";
import { fetchLogicalDevices } from "../../../store/devices/logicalDevices";

import "../../../components/devices/TableDevices.scss";
import "./Devices.scss";

export const Devices = () => {
  const [selectedType, setSelectedType] = useState(DevicesSets.Discovered);
  const showSPSON = useSelector(isSPSONAvailable);
  const intl = useIntl();
  const dispatch = useDispatch();

  const tabs = useMemo(() => {
    const filteredTabs = showSPSON
      ? TABS
      : _.reject(TABS, {
          value: DevicesSets.Roaming,
        });

    return filteredTabs.map((tab) => createDeviceTab(tab, intl));
  }, [showSPSON, intl]);

  const handleTabChange = useCallback(
    (type) => {
      setSelectedType(type);
      type === DevicesSets.Discovered && dispatch(fetchNewDevices());
    },
    [dispatch]
  );

  useMount(() => {
    dispatch(fetchLogicalDevices());
    dispatch(fetchInfected());
    dispatch(fetchLines());
    dispatch(fetchNewDevices());
  });

  const tabsContext = {
    tabs,
    selectedTab: selectedType,
    onSelectedChange: handleTabChange,
  };

  return (
    <section className="reporting-devices">
      <h2 className="reporting-devices__title">
        <FormattedMessage id="network_device" />
      </h2>
      <div className={"devices__layout"}>
        <TabsContext.Provider value={tabsContext}>
          {renderDevicesTable(selectedType, { showRoaming: showSPSON })}
        </TabsContext.Provider>
      </div>
    </section>
  );
};

const renderDevicesTable = (type, { showRoaming }) => {
  if (type === DevicesSets.Discovered) return <DiscoveredDevicesTable />;
  if (type === DevicesSets.Infected) return <InfectedDevicesTable />;
  if (type === DevicesSets.Blocked) return <BlockedDevicesTable />;
  if (type === DevicesSets.Roaming && showRoaming)
    return <RoamingDevicesTable />;
  return null;
};
